import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Login from "./login/login";
import Register from "./register/register";
import AdminNavbar from "./admin/adminNavbar";
import AdminQrcode from "./admin/adminQrcode";
import AdminUpload from "./admin/adminUpload";
import AdminVisitors from "./admin/adminVisitors";
import AdminLanguage from "./admin/adminLanguage";
import axios from "axios";
import App from "../App";
import { ToastContainer, toast } from "react-toastify";
import Visitor from "./visitor/visitor";
import Spinner from "react-bootstrap/Spinner";
import {
  AddUser,
  ChangeAuthentication,
  RemoveUser,
} from "./redux/Actions/UserActions";
import { AddMuseum, RemoveMuseum } from "./redux/Actions/MuseumActions";
import { AddUUID, RemoveUUID } from "./redux/Actions/UUIDActions";
import { RemoveAccessToken } from "./redux/Actions/AccessTokenActions";
import { connect } from "react-redux";

class Home extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
    this.state = { loading: false, onceLoaded: false };
  }

  toastMessagePopUp = (message) => {
    // toast error message popup
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  loginloader = () => {
    // shows loader if the user presses login button
    this.setState({ loading: true });
  };

  stoploader = () => {
    // stops loader if we recieve data from user api
    this.setState({ loading: false });
  };

  onceLoaded = () => {
    // used to stop user from registering more than once as setState is slower than code and code tries to fetch data again
    this.setState({ onceLoaded: false });
  };

  loginUser = () => {
    // login user function
    if (this.props.access_token) {
      // we login only if we get access token from the auth api on login component
      this.loginloader();
      // start the loader
      axios
        .get(App.baseUrl + "account-details")
        .then((resp) => {
          this.props.AddUser(resp.data);
          if (resp.data.roles[0] === "museum-admin") {
            // if we get user role as a museum admin then we call get details by museum id
            let museum_id = resp.data.museum_id;
            axios
              .get(App.baseUrl + "api/museum/" + museum_id)
              .then((data) => {
                this.props.AddMuseum(data.data);
                this.props.ChangeAuthentication();
                this.stoploader();
              })
              .catch((error) => {
                if (error.response) {
                  this.toastMessagePopUp(error.response.status_code);
                } else {
                  this.toastMessagePopUp(
                    "Something went wrong, please check your Internet connection or refresh the page"
                  );
                }
                this.stoploader();
              });
          } else if (resp.data.roles[0] === "visitor") {
            // if we get user role as a visitor then we call get museum details using museum uuid
            if (this.props.UUID) {
              let uuid = this.props.UUID;
              const jsonObject = {
                filters: [
                  {
                    name: "uuid",
                    op: "eq",
                    val: uuid,
                  },
                ],
                single: "true",
              };
              axios
                .get(App.baseUrl + "api/museum", {
                  params: {
                    q: JSON.stringify(jsonObject),
                  },
                })
                .then((data) => {
                  if (this.state.onceLoaded === false && !this.props.userAuth) {
                    // if we get museum details from uuid, it suggests that uuid is valid so we let the visitor register to that musuem once
                    this.setState({ onceLoaded: true }, () => {
                      axios
                        .post(App.baseUrl + "api/visitor", {
                          museum: data.data.id,
                        })
                        .then((data) => {})
                        .catch((error) => {
                          this.toastMessagePopUp(
                            "Something went wrong, please refresh page and try again"
                          );
                          this.logout();
                        });
                    });
                  }
                  this.stoploader();
                  this.props.AddMuseum(data.data);
                  this.props.ChangeAuthentication();
                })
                .catch((error) => {
                  // if uuid is not valid
                  this.toastMessagePopUp("Scan a vaild QR code");
                  this.logout();
                });
            } else {
              // if uuid is not valid
              this.toastMessagePopUp("Scan a vaild QR code");
              this.logout();
            }
            // this.setState({ loading: false });
          } else {
            // do logu=ou if we do not get proper museum details
            this.logout();
          }
        })
        .catch((error) => {
          if (error.response) {
            let message = "Unauthorised";
            this.toastMessagePopUp(message);
          }
          // if we are not authorised 401 error which is also handled on the axios interceptor on the index.jsx file
          this.logout();
        });
      // this.setState({ loading: false });
    } else {
      // if there is no access_token the do a logout
      this.logout();
    }
  };

  logout = () => {
    // logout function clears everything from the redux state and stops the loader
    this.onceLoaded();
    this.stoploader();
    this.props.RemoveAccessToken();
    this.props.RemoveUser();
    this.props.RemoveMuseum();
    this.props.RemoveUUID();
  };

  componentDidMount() {
    if (this.props.access_token) {
      // do login user if we have access token , case applicable if we do refresh after login
      this.loginUser();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // calls if the redux values in props changes
    if (this.props.access_token && prevProps.userAuth !== this.props.userAuth) {
      this.loginUser();
    }
    if (
      !this.props.access_token &&
      prevProps.userAuth !== this.props.userAuth
    ) {
      this.logout();
    }
  }

  saveUuidToLocal = (UUID) => {
    // let uuid = "login/95e66658-9122-4a99-a332-9803fb0843a5";
    let uuid = UUID.match.params.uuid;
    // uuid is here at UUID.match.params.uuid
    this.props.AddUUID(uuid);
  };

  render() {
    let authorization = this.props.userAuth;
    let loading = this.state.loading;
    return (
      <div>
        {authorization ? <AdminNavbar logout={this.logout} /> : null}
        <Switch>
          <Route
            exact
            path="/"
            render={() =>
              !authorization ? (
                <Redirect to="/login" />
              ) : this.props.user.roles[0] === "museum-admin" ? (
                <Redirect to="/admin/visitor" />
              ) : this.props.user.roles[0] === "visitor" ? (
                <Redirect to="/visitor" />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/login/:uuid"
            render={(uuid) => {
              this.saveUuidToLocal(uuid);
              if (this.props.UUID) {
                return <Redirect to="/login" />;
              }
            }}
          />
          <Route
            exact
            path="/login"
            render={() =>
              loading ? (
                <Spinner animation="border" id="spinner-loading-show" />
              ) : !authorization ? (
                <Login
                  loginloader={this.loginloader}
                  loginUser={this.loginUser}
                />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/register"
            render={() => (!authorization ? <Register /> : <Redirect to="/" />)}
          />

          <Route
            exact
            path="/visitor"
            render={() =>
              authorization && this.props.user.roles[0] === "visitor" ? (
                <Visitor logout={this.logout} />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/admin/visitor"
            render={() =>
              authorization && this.props.user.roles[0] === "museum-admin" ? (
                <AdminVisitors />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/admin/qrcode"
            render={() =>
              authorization && this.props.user.roles[0] === "museum-admin" ? (
                <AdminQrcode />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/admin/upload"
            render={() =>
              authorization && this.props.user.roles[0] === "museum-admin" ? (
                <AdminUpload />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route
            exact
            path="/admin/language"
            render={() =>
              authorization && this.props.user.roles[0] === "museum-admin" ? (
                <AdminLanguage />
              ) : (
                <Redirect to="/" />
              )
            }
          />
          <Route exact path="" render={() => <Redirect to="/" />} />

          <Redirect to="/" />
        </Switch>
        <ToastContainer
          limit={1}
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.userData.userData,
    userAuth: state.userData.userAuthorization,
    UUID: state.UUIDData.UUID,
    access_token: state.AccessTokenData.accessToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddUser: (data) => dispatch(AddUser(data)),
    RemoveUser: () => dispatch(RemoveUser()),
    AddMuseum: (data) => dispatch(AddMuseum(data)),
    RemoveMuseum: () => dispatch(RemoveMuseum()),
    ChangeAuthentication: () => dispatch(ChangeAuthentication()),
    AddUUID: (data) => dispatch(AddUUID(data)),
    RemoveUUID: () => dispatch(RemoveUUID()),
    RemoveAccessToken: () => dispatch(RemoveAccessToken()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
